module.exports = __webpack_public_path__ + "img/settled.5897146a.png";